import { FC } from 'react';

import { Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { StorageSystemForm } from '@/types/storageSystem';
import { normalizePositiveNumericValuesInput } from '@/utils';

type Props = {
  disabled?: boolean;
};

const GridAction: FC<Props> = ({ disabled = false }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  //const { currencySymbol } = useCurrency();

  return (
    <Form.Item
      wrapperCol={{ span: 24 }}
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
      className="p-16"
    >
      <Row>
        <Col span={24}>
          <Form.Item<StorageSystemForm>
            className="pr-8"
            name="gridPowerConstraintOutflow"
            label={t(
              'storageSystem.form.gridActions.gridPowerConstraintOutflow.label'
            )}
            normalize={normalizePositiveNumericValuesInput}
            rules={[
              {
                required: true,
                message: t(
                  'storageSystem.form.gridActions.gridPowerConstraintOutflow.requiredMessage'
                ),
              },
            ]}
          >
            <Input
              disabled={disabled}
              addonAfter="MW"
              placeholder={t(
                'storageSystem.form.gridActions.gridPowerConstraintOutflow.placeholder'
              )}
            />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item<StorageSystemForm>
            tooltip={{
              title: (
                <div>
                  <>
                    <Typography.Text className="fs-14-semi-bold">
                      {t(
                        'storageSystem.form.gridActions.distributionFeePerMwh.label'
                      )}
                    </Typography.Text>
                    <div className="horizontal-line mt-4"></div>
                  </>
                  <Typography.Text className="fs-14-regular smoke mt-4">
                    {t(
                      'storageSystem.form.gridActions.distributionFeePerMwh.tooltip.description'
                    )}
                  </Typography.Text>
                </div>
              ),
              styles: {
                body: {
                  padding: theme.spacing.spacing12 + 'px',
                  color: 'inherit',
                },
              },
              color: theme.colors.light,
            }}
            className="pl-8"
            name="distributionFeePerMwh"
            label={t(
              'storageSystem.form.gridActions.distributionFeePerMwh.label'
            )}
            normalize={normalizePositiveNumericValuesInput}
          >
            <Input
              disabled={disabled}
              addonAfter={`${currencySymbol}/MWh`}
              placeholder={t(
                'storageSystem.form.gridActions.distributionFeePerMwh.placeholder'
              )}
            />
          </Form.Item>
        </Col> */}
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item<StorageSystemForm>
            className="pr-8"
            name="gridPowerConstraintInflow"
            label={t(
              'storageSystem.form.gridActions.gridPowerConstraintInflow.label'
            )}
            normalize={normalizePositiveNumericValuesInput}
            rules={[
              {
                required: true,
                message: t(
                  'storageSystem.form.gridActions.gridPowerConstraintInflow.requiredMessage'
                ),
              },
            ]}
          >
            <Input
              disabled={disabled}
              addonAfter="MW"
              placeholder={t(
                'storageSystem.form.gridActions.gridPowerConstraintInflow.placeholder'
              )}
            />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item<StorageSystemForm>
            className="pl-8"
            name="withdrawalFeePerMwh"
            label={t(
              'storageSystem.form.gridActions.withdrawalFeePerMwh.label'
            )}
            normalize={normalizePositiveNumericValuesInput}
            tooltip={{
              title: (
                <div>
                  <>
                    <Typography.Text className="fs-14-semi-bold">
                      {t(
                        'storageSystem.form.gridActions.withdrawalFeePerMwh.label'
                      )}
                    </Typography.Text>
                    <div className="horizontal-line mt-4"></div>
                  </>
                  <Typography.Text className="fs-14-regular smoke mt-4">
                    {t(
                      'storageSystem.form.gridActions.withdrawalFeePerMwh.tooltip.description'
                    )}
                  </Typography.Text>
                </div>
              ),
              styles: {
                body: {
                  padding: theme.spacing.spacing12 + 'px',
                  color: 'inherit',
                },
              },
              color: theme.colors.light,
            }}
          >
            <Input
              disabled={disabled}
              addonAfter={`${currencySymbol}/MWh`}
              placeholder={t(
                'storageSystem.form.gridActions.withdrawalFeePerMwh.placeholder'
              )}
            />
          </Form.Item>
        </Col> */}
      </Row>
    </Form.Item>
  );
};

export default GridAction;
